<template>
  <div class="most-predicted-list">
    <div class="most-predicted-list__header">
      <div class="most-predicted-list__header-title">New Arrivals</div>
      <slot name="pin"></slot>
      <div class="most-predicted-list__header-arrows" v-if="isLayoutMobile">
        <span @click="prevSlide" :class="prevArrowModifiers"></span>
        <span @click="nextSlide" :class="nextArrowModifiers"></span>
      </div>
    </div>
    <div class="content-loader" v-if="!isComponentReady">
      <div class="content-loader-item" v-for="index in dummyComponents" :key="index">
        <market-loader></market-loader>
      </div>
    </div>
    <div v-else class="most-predicted-list__content">
      <template v-if="isLayoutDesktop">
        <market-list-item
          class="most-predicted-list__item"
          v-for="market in items"
          :market="market"
          :key="market.marketId"
          theme="home"
        >
        </market-list-item>
      </template>
      <template v-if="isLayoutMobile">
        <swiper
          v-bind="swiperOptions"
          ref="swiper"
          @swiper="onSwiperReady"
          @transitionStart="onTransitionStart"
        >
          <swiper-slide v-for="item in items" :key="item.marketId">
            <market-list-item class="most-predicted-list__item" :market="item" theme="home">
            </market-list-item>
          </swiper-slide>
        </swiper>
      </template>
    </div>
  </div>
</template>
<script src="./most-predicted-list.js"></script>
<style src="./most-predicted-list.scss" lang="scss"></style>
